{
  "es": {
    "locale_field": {
      "fallback_tooltip": "Cuando no se introduce texto para este idioma, se usará este texto predeterminado como alternativa.",
      "fill_missing": "Completar el idioma que falta ({count}) | Completar idiomas que faltan ({count})",
      "fill_missing_budget_used": "El presupuesto de IA de este mes se ha agotado.",
      "fill_missing_done": "Idiomas que faltaban completados. Revisa el texto antes de guardar.",
      "fill_missing_errors": {
        "budget_reached": "El presupuesto de IA de este mes se ha agotado. Contacta con Ziggu para aumentarlo.",
        "generic": "No se han podido completar los idiomas. Inténtalo de nuevo.",
        "too_long": "Este texto es demasiado largo para traducirlo de una vez."
      },
      "fill_missing_tooltip": "Traduce desde {language} con IA. Revisa el texto antes de guardar.",
      "translated_in": "Traducido en"
    }
  }
}
